import { render, staticRenderFns } from "./HistoricNfe.vue?vue&type=template&id=ce674ad4&scoped=true"
import script from "./HistoricNfe.vue?vue&type=script&lang=js"
export * from "./HistoricNfe.vue?vue&type=script&lang=js"
import style0 from "./HistoricNfe.vue?vue&type=style&index=0&id=ce674ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce674ad4",
  null
  
)

export default component.exports